export const selectDepartments = (state) => state.departmentState.departments;
export const selectSelectedDepartment = (state) => state.departmentState.selectedDepartment;
export const selectIsDepartmentReady = (state) => state.departmentState.isDepartmentReady;
